import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=c40868ca&"
import script from "./editPassword.vue?vue&type=script&lang=ts&"
export * from "./editPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports